import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import { clearSearchBtn } from '../includes/utils';

export function CsfPivotalFournisseurFormateurListModal({ lists, currentLists }) {

  const [inputSearchValue, setInputSearchValue] = useState('');
  const [filteredLists, setFilteredLists] = useState([]);

  useEffect(() => {
    // Set filtered regions only after props are received
    if (lists && lists.length > 0) {
      setFilteredLists([...lists]);
    }
  }, [lists]); // Dependency on regions

  const handleSearchChange = (event) => {
    setInputSearchValue(event.target.value);
  };

  const handleSearchBtn = (event) => {
    if (event.key === 'Enter' || event.type === "click") {
      setFilteredLists(filterRegions(inputSearchValue));
    }
  };

  const filterRegions = (inputSearchValue) => {
    if (!inputSearchValue) {
      // If search term is empty, return all regions
      return lists;
    }

    const filtered = lists.filter((region) =>
      region.label.toLowerCase().includes(inputSearchValue.toLowerCase())
    );
    return filtered;
  };

  return (
    <div className="modal fade modal-fixed-height" id="addFormateurToList" tabIndex="-1" role="dialog" aria-labelledby="addTrainerTitle" aria-hidden="true">
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h2 id="addTrainerTitle">
              {window.Drupal.t('fournisseur.add.formateur.list.modal.title')}
            </h2>
            <button type="button" className="close" data-dismiss="modal" aria-label={window.Drupal.t('lang.modal.close')}>
              <i className="icon icon-csf-close-noborder"><span className="d-none">&nbsp;</span></i>
            </button>
          </div>

          <div className="modal-body">
            <div className="modal-list">
              {/* Searchbox  */}
              <div className="search-container">
                <label htmlFor="txtSearch" className="sr-only">Filtres</label>
                <input type="search" id="txtSearch" value={inputSearchValue} onChange={handleSearchChange} onKeyDown={handleSearchBtn}
                  placeholder={window.Drupal.t('fournisseur.search.placeholder')} />
                <button className="search-close-icon btn-link" aria-label={window.Drupal.t('fournisseur.search.clear.label')}
                  onClick={(e) => clearSearchBtn(e, setInputSearchValue)}>
                  <i className="icon icon-remove"></i>
                </button>
                <button className="button btn-outlined search-icon" onClick={handleSearchBtn}
                  title={window.Drupal.t('search.label')} aria-label={window.Drupal.t('search.label')}>
                  <i className="icon icon-search-2"><span className="d-none">&nbsp;</span></i>
                </button>
              </div>

              <h3>{window.Drupal.t('fournisseur.add.formateur.list.modal.header')}</h3>
              <ul>
                {
                  filteredLists.map((list) => {
                    return !currentLists.some(curList => curList.list === list.label) && (
                      <li key={`${list.value}`}>
                        <div className="form-group">
                          <input id={list.value} value={list.value} data-label={list.label} type="checkbox" name="listSelected" />
                          <label htmlFor={list.value}>{list.label}</label>
                        </div>
                      </li>
                    );
                  })
                }
              </ul>
            </div>
          </div>

          <div className="modal-footer">
            <div className="container">
              <div className="modal-pagination">
                {/* if there is one, Pagination goes here */}
              </div>
              <div className="modal-actions">
                <button type="button" className="button btn-outlined btn-larger" data-dismiss="modal">{window.Drupal.t('fournisseur.cancel.btn')}</button>
                <button type="button" className="button btn-larger" id="modalSaveButton">{window.Drupal.t('fournisseur.creation_form.form.add')}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

CsfPivotalFournisseurFormateurListModal.propTypes = {
  lists: PropTypes.array.isRequired,
  currentLists: PropTypes.array,
};
